module.exports = __webpack_public_path__ + "static/fiji1-300x266-d1799719b8eb3e691236b85272254d08.png";